import React, { Component } from 'react';
import '../Common/Common.css';
import OrdersView from './OrdersView';
import ViewOrders from './ViewOrders';
import StatusChangeOrders from './StatusChangeOrders';
import CreateInvoice from './CreateInvoice';
import CreateOrderDrawer from '../NormalOrders/CreateOrderDrawer';
import { withRouter } from 'react-router-dom';
import {
  Table,
  Card,
  Row,
  Col,
  Form,
  Image,
  Tab,
  Tabs,
  Button,
} from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';

var dateFormat = require('dateformat');

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOrdersDetailModal: false,
      showViewOrdersDetailModal: false,
      showOrderStatusModel: false,
      page: 0,
      perPage: 10,

      searchurgentorder: '',

      filterValue: '',
      key: 'new',
      inprogressp: 0,
      perPaginprogress: 10,
      processedOrderspage: 0,
      processedOrdersperpage: 10,
      deliveredOrderspage: 0,
      deliveredOrdersperpage: 10,
      cancelledOrderspage: 0,
      cancelledOrdersperpage: 10,

      searchurgentprogress: '',
      srchurgentComplete: '',
      srchurgentCancel: '',

      filterurgentprogress: '',
      filterurgentcomplete: '',
      filterurgentcancel: '',
      ordersToShow: [],
      showInvoiceModal: false,
      isCreateOrderDrawerOpen: false,
    };
  }
  componentDidMount() {
    this.props.fetchChemistOrders({
      page: undefined,
      searchKey: this.state.searchurgentorder,
      filter: this.state.filterValue,
    });

    this.props.fetchChemistInprogressOrders({
      page: undefined,
      searchKey: this.state.searchurgentprogress,
      filter: this.state.filterurgentprogress,
    });

    this.props.fetchChemistCompletedOrders({
      page: undefined,
      searchKey: this.state.srchurgentComplete,
      filter: this.state.filterurgentcomplete,
    });

    this.props.fetchChemistCancelledOrders({
      page: undefined,
      searchKey: this.state.srchurgentCancel,
      filter: this.state.filterurgentcancel,
    });

    this.props.fetchDeliveryStatus();
    this.setState({
      ...this.state,
      key:
        (this.props.location && this.props.location.activeTab) ||
        this.state.key,
    });
  }

  componentDidUpdate(prevProps) {
    const previousTab = prevProps.location && prevProps.location.activeTab;
    const activeTab = this.props.location && this.props.location.activeTab;

    if (activeTab && activeTab !== previousTab && activeTab !== this.state.key) {
      this.setState({ key: activeTab });
    }
  }

  showOrdersDetail = item => {
    this.setState(
      {
        ...this.state,
        showOrdersDetailModal: true,
        ordersToShow: item,
      },
      () => {
        this.props.ChemistOrdersview({
          item: this.state.ordersToShow,
          page: undefined,
        });
      }
    );
  };

  closeOrdersDetailModal = () => {
    this.setState({
      showOrdersDetailModal: false,
    });
  };

  showViewOrdersDetail = item => {
    this.setState({
      showViewOrdersDetailModal: true,
      ordersToShow: item,
    });
    this.props.ChemistOrdersview(item);
  };

  closeViewOrdersDetailModal = () => {
    this.setState({
      showViewOrdersDetailModal: false,
    });
  };

  handleOrderStatus = item => {
    this.setState({
      showOrderStatusModel: true,
      OrderStatusdtList: item,
    });
  };
  closeOrderStatusModel = () => {
    this.setState({
      showOrderStatusModel: false,
    });
  };

  InvoiceModal = item => {
    this.setState({
      showInvoiceModal: true,
      InvoiceDetails: item,
    });
    this.props.Totalitemretrieval(item);
  };

  closeInvoiceModal = () => {
    this.setState({
      showInvoiceModal: false,
    });
  };

  handlePageClick = e => {
    const selectedPage = e.selected;
    this.props.pageSelected({
      page: selectedPage + 1,
      searchKey: this.state.searchurgentorder,
      filter: this.state.filterValue,
    });
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  handleprogressPageClick = e => {
    const selectedprogressPage = e.selected;
    this.props.progresspageSelected({
      page: selectedprogressPage + 1,
      searchKey: this.state.searchurgentprogress,
      filter: this.state.filterurgentprogress,
    });
    this.setState({ processedOrderspage: selectedprogressPage });
  };
  resetprogressPage = () => {
    this.setState({ processedOrderspage: 0 });
  };
  handledeliveredPageClick = e => {
    const selecteddeliveredPage = e.selected;
    this.props.deliveredpageSelected({
      page: selecteddeliveredPage + 1,
      searchKey: this.state.srchurgentComplete,
      filter: this.state.filterurgentcomplete,
    });
    this.setState({ deliveredOrderspage: selecteddeliveredPage });
  };

  resetdeliveredPage = () => {
    this.setState({ deliveredOrderspage: 0 });
  };

  handlecancelledPageClick = e => {
    const selectedcancelledPage = e.selected;
    this.props.cancelledpageSelected({
      page: selectedcancelledPage + 1,
      searchKey: this.state.srchurgentCancel,
      filter: this.state.filterurgentcancel,
    });
    this.setState({ cancelledOrderspage: selectedcancelledPage });
  };

  resetcancelledPage = () => {
    this.setState({ cancelledOrderspage: 0 });
  };

  newurgentonChange = ev => {
    let name = ev.target.name;
    let val = ev.target.value;
    if (name === 'srchnw') {
      this.setState(
        {
          ...this.state,
          page: 0,
          filterValue: '',
          searchurgentorder: val,
        },
        () => {
          this.props.fetchChemistOrders({
            page: undefined,
            searchKey: this.state.searchurgentorder,
            filter: this.state.filterValue,
          });
        }
      );
    } else if (name === 'srchprogress') {
      this.setState(
        {
          ...this.state,
          processedOrderspage: 0,
          searchurgentprogress: val,
          filterurgentprogress: '',
        },
        () => {
          this.props.fetchChemistInprogressOrders({
            page: undefined,
            searchKey: this.state.searchurgentprogress,
            filter: this.state.filterurgentprogress,
          });
        }
      );
    } else if (name === 'srchurgentComplete') {
      this.setState(
        {
          ...this.state,
          deliveredOrderspage: 0,
          srchurgentComplete: val,
          filterurgentcomplete: '',
        },
        () => {
          this.props.fetchChemistCompletedOrders({
            page: undefined,
            searchKey: this.state.srchurgentComplete,
            filter: this.state.filterurgentcomplete,
          });
        }
      );
    } else if (name === 'srchurgentCancel') {
      this.setState(
        {
          ...this.state,
          cancelledOrderspage: 0,
          srchurgentCancel: val,
          filterurgentcancel: '',
        },
        () => {
          this.props.fetchChemistCancelledOrders({
            page: undefined,
            searchKey: this.state.srchurgentCancel,
            filter: this.state.filterurgentcancel,
          });
        }
      );
    }
  };

  filterurgentChange = ev => {
    let filtername = ev.target.name;
    let filterval = ev.target.value;
    if (filtername === 'newfilter') {
      this.setState(
        {
          ...this.state,
          page: 0,
          filterValue: filterval,
          searchurgentorder: '',
        },
        () => {
          this.props.fetchChemistOrders({
            page: undefined,
            searchKey: this.state.searchurgentorder,
            filter: this.state.filterValue,
          });
        }
      );
    } else if (filtername === 'progressfilter') {
      this.setState(
        {
          ...this.state,
          processedOrderspage: 0,
          filterurgentprogress: filterval,
          searchurgentprogress: '',
        },
        () => {
          this.props.fetchChemistInprogressOrders({
            page: undefined,
            searchKey: this.state.searchurgentprogress,
            filter: this.state.filterurgentprogress,
          });
        }
      );
    } else if (filtername === 'completefilter') {
      this.setState(
        {
          ...this.state,
          deliveredOrderspage: 0,
          filterurgentcomplete: filterval,
          srchurgentComplete: '',
        },
        () => {
          this.props.fetchChemistCompletedOrders({
            page: undefined,
            searchKey: this.state.srchurgentComplete,
            filter: this.state.filterurgentcomplete,
          });
        }
      );
    } else if (filtername === 'cancelfilter') {
      this.setState(
        {
          ...this.state,
          cancelledOrderspage: 0,
          filterurgentcancel: filterval,
          srchurgentCancel: '',
        },
        () => {
          this.props.fetchChemistCancelledOrders({
            page: undefined,
            searchKey: this.state.srchurgentCancel,
            filter: this.state.filterurgentcancel,
          });
        }
      );
    }
  };

  renderTooltip = props =>
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>;

  shipmentTooltip = props =>
    <Tooltip id="button-tooltip" {...props}>
      Ready for shipment
    </Tooltip>;

  handleCreateOrder = () => {
    this.setState({ isCreateOrderDrawerOpen: true });
  };

  closeCreateOrderDrawer = () => {
    this.setState({ isCreateOrderDrawerOpen: false });
  };

  render() {
    const count = this.props.chemistOrdersCount;
    let p = this.state.page + 1;
    let chemistorderspageCount = Math.ceil(count / this.state.perPage);

    const inprogresscount = this.props.chemistinprogressOrderCount;
    let p4 = this.state.processedOrderspage + 1;
    let inprogresspageCount = Math.ceil(
      inprogresscount / this.state.processedOrdersperpage
    );

    const completecount = this.props.chemistcompleteOrderCount;
    let p5 = this.state.deliveredOrderspage + 1;
    let completepageCount = Math.ceil(
      completecount / this.state.deliveredOrdersperpage
    );

    const cancelledcount = this.props.chemistcancelledOrderCount;
    let p6 = this.state.cancelledOrderspage + 1;
    let cancelledOrdersPageCount = Math.ceil(
      cancelledcount / this.state.cancelledOrdersperpage
    );

    const {
      chemistinprogressOrderDetails,
      chemistinprogressOrderCount,
      chemistcompleteOrderDetails,
      chemistcompleteOrderCount,
      chemistcancelledOrderDetails,
      chemistcancelledOrderCount,
      completeitemDetails,
      completeitemDetailsCount,
      manualInvoice,
      OrdersViewpageSelected,
      itemViewpageSelected,
      ordercount,
      changePaymentstatus,
      UrgentordersDelivered,
    } = this.props;

    const {
      key,
      searchurgentorder,
      searchurgentprogress,
      srchurgentComplete,
      srchurgentCancel,
      filterValue,
      filterurgentprogress,
      filterurgentcomplete,
      filterurgentcancel,
      showInvoiceModal,
      InvoiceDetails,
      ordersToShow,
      isCreateOrderDrawerOpen,
    } = this.state;

    const {
      newurgentonChange,
      filterurgentChange,
      InvoiceModal,
      closeInvoiceModal,
      itemsPageClick,
    } = this;
    return (
      <div className="salesreturndiv">
        <Card>
          <Tabs
            activeKey={key}
            onSelect={k => this.setState({ ...this.state, key: k })}
          >
            <Tab eventKey="new" title="New">
              <div className="tabsdiv">
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <h5 className="tablecardtitle">Urgent Orders - New</h5>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="commonInputdiv">
                      <div className="commonInput">
                        <i className="fa fa-search fa-lg cmnSearchIcon" />
                        <input
                          type="text"
                          name="srchnw"
                          placeholder="Order ID / Org Name"
                          value={searchurgentorder}
                          onChange={newurgentonChange}
                        />
                      </div>
                    </div>
                  </Col>


                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="salescommonRecrd">
                      <i className="cui-note icons cmnRecordIcon" />
                      <span className="cmnPageCount">
                        {count === undefined
                          ? 0
                          : <span>
                            {count}
                          </span>}
                      </span>
                      <span className="cmnResutText">Results</span>
                    </div>
                  </Col>

                  <Col xs={12} sm={12} md={3} lg={3} className="text-md-end mt-2 mt-md-0">
                    <Button variant="primary" onClick={this.handleCreateOrder}>
                      <i className="fa fa-plus" style={{ marginRight: "8px" }}></i>
                      Create Order
                    </Button>
                  </Col>
                </Row>
              </div>

              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Order ID</th>
                    <th>Chemist Name</th>
                    <th>Organization Name</th>
                    <th>Payment Mode</th>
                    <th>Created Date</th>
                    <th>Delivery within</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {this.props.chemistOrderDetails &&
                    this.props.chemistOrderDetails.map((item, i) =>
                      <tr key={i}>
                        <th scope="row">
                          {10 * (p - 1) + i + 1}
                        </th>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.orderNo
                            ? item.orderNo
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFrom
                            ? item.orderFrom.name + ' ' + item.orderFrom.lName
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFromName}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.payMode ? item.payMode : null}
                        </td>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.createdAt
                            ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.trkDuratn
                            ? item.trkDuratn
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.status &&
                            (item.status === 'confirm'
                              ? <span className="badge badge-primary">
                                Accepted
                              </span>
                              : <span className="badge badge-primary">
                                {item.status}
                              </span>)}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              marginLeft: '15px',
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.showOrdersDetail({ item: item })}
                              />
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>

              <CreateOrderDrawer
                show={this.state.isCreateOrderDrawerOpen}
                onClose={this.closeCreateOrderDrawer}
                orderTrk="urgent"
                onSuccess={() => this.props.fetchChemistOrders({
                  page: undefined,
                  searchKey: this.state.searchurgentorder,
                  filter: this.state.filterValue,
                })}
              />

              <OrdersView
                show={this.state.showOrdersDetailModal}
                close={this.closeOrdersDetailModal}
                ordersToShow={ordersToShow}
                chemistOrderDtls={this.props.chemistOrderDtls}
                chemistOrderDtlsCount={this.props.chemistOrderDtlsCount}
                EditItemDetails={this.props.EditItemDetails}
                ordersInActive={this.props.ordersInActive}
                OrdersViewpageSelected={this.props.OrdersViewpageSelected}
                resetPage={this.resetPage}
                itemsPageClick={itemsPageClick}
                ordercount={ordercount}
                changePaymentstatus={changePaymentstatus}
                pdfOrderFullData={this.props.pdfOrderFullData}
                fetchChemistitems={this.props.fetchChemistitems}
                chemistOrderSearchList={this.props.chemistOrderSearchList}
                chemistOrderSearchCount={this.props.chemistOrderSearchCount}
                UrgentordersDelivered={UrgentordersDelivered}
              />

              {(this.props.chemistOrderDetails === undefined ||
                (this.props.chemistOrderDetails &&
                  this.props.chemistOrderDetails.length === 0)) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">No new orders to show!</div>
                </div>}
              {chemistorderspageCount > 1
                ? <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={this.state.page}
                    previousLabel={'Prev'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={chemistorderspageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination flex-wrap'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                </div>
                : null}
            </Tab>

            <Tab eventKey="processing" title="In Progress">
              <div className="tabsdiv">
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <h5 className="tablecardtitle">
                        Urgent Orders - In Progress
                      </h5>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="commonInputdiv">
                      <div className="commonInput">
                        <i className="fa fa-search fa-lg cmnSearchIcon" />
                        <input
                          type="text"
                          name="srchprogress"
                          placeholder="Order ID / Org Name"
                          value={searchurgentprogress}
                          onChange={newurgentonChange}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="salescommonRecrd">
                      <i className="cui-note icons cmnRecordIcon" />
                      <span className="cmnPageCount">
                        {inprogresscount === undefined
                          ? 0
                          : <span>
                            {inprogresscount}
                          </span>}
                      </span>
                      <span className="cmnResutText">Results</span>
                    </div>
                  </Col>
                </Row>
              </div>

              <Table hover responsive className="">
                <thead className="tablecommonCard ">
                  <tr>
                    <th>#</th>
                    <th>Order ID</th>
                    <th>Chemist Name</th>
                    <th>Organization Name</th>
                    <th>Payment Mode</th>
                    <th>Created Date</th>

                    <th>Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {chemistinprogressOrderDetails !== undefined &&
                    chemistinprogressOrderCount !== 0 &&
                    chemistinprogressOrderDetails.map((item, i) =>
                      <tr key={i}>
                        <th scope="row">
                          {10 * (p4 - 1) + i + 1}
                        </th>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.orderNo
                            ? item.orderNo
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFrom
                            ? item.orderFrom.name + ' ' + item.orderFrom.lName
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFromName}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.payMode ? item.payMode : null}
                        </td>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.createdAt
                            ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                            : null}
                        </td>

                        <td className="cmn_Cap">
                          {item !== null && item.hasCreated
                            ? <p>
                              {item !== null && item.invDtls.amount
                                ? 'INR ' + item.invDtls.amount
                                : null}
                            </p>
                            : <div onClick={() => InvoiceModal({ item: item })}>
                              <i
                                className="nav-icon fa fa-upload"
                                style={{
                                  fontSize: '15px',
                                  justifyContent: 'center',
                                  display: 'flex',
                                }}
                              />
                              <p className="uploadinvoice">Upload Invoice </p>
                            </div>}
                        </td>

                        <td className="cmn_Cap">
                          {item !== null &&
                            item.status &&
                            (item.hasCreated && item.status === 'accepted')
                            ? <span className="badge badge-warning">
                              Not paid
                            </span>
                            : <span className="badge badge-success">
                              {item.status}
                            </span>}
                        </td>

                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.showOrdersDetail({ item: item })}
                              />
                            </OverlayTrigger>

                            {item !== null &&
                              ((item.payType === 'payNow' &&
                                item.invDtls &&
                                item.invDtls.status === 'paid') ||
                                (item.hasCreated &&
                                  item.status === 'accepted' &&
                                  item.payType === 'payLater') ||
                                (item.payType === 'payLater' &&
                                  item.invDtls &&
                                  item.invDtls.status === 'paid'))
                              ? <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.shipmentTooltip}
                              >
                                <i
                                  className="nav-icon fa fa-paper-plane"
                                  style={{
                                    paddingLeft: 10,
                                    fontSize: '15px',
                                  }}
                                  onClick={() =>
                                    this.handleOrderStatus({
                                      item: item,
                                    })}
                                />
                              </OverlayTrigger>
                              : null}
                          </div>
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
              <ViewOrders
                show={this.state.showViewOrdersDetailModal}
                close={this.closeViewOrdersDetailModal}
                ordersToShow={this.state.ordersToShow}
                chemistOrderDtls={this.props.chemistOrderDtls}
                chemistOrderDtlsCount={this.props.chemistOrderDtlsCount}
                EditItemDetails={this.props.EditItemDetails}
                ordersInActive={this.props.ordersInActive}
                OrdersViewpageSelected={this.props.OrdersViewpageSelected}
                resetprogressPage={this.resetprogressPage}
              />

              <CreateInvoice
                show={showInvoiceModal}
                close={closeInvoiceModal}
                InvoiceDetails={InvoiceDetails}
                completeitemDetails={completeitemDetails}
                completeitemDetailsCount={completeitemDetailsCount}
                manualInvoice={manualInvoice}
              />

              <StatusChangeOrders
                showOrderStatusModel={this.state.showOrderStatusModel}
                closeOrderStatusModel={this.closeOrderStatusModel}
                deliverystatusList={this.props.deliverystatusList}
                OrderStatusdtList={this.state.OrderStatusdtList}
                ordersShippedActive={this.props.ordersShippedActive}
              />

              {inprogresspageCount > 1
                ? <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={this.state.processedOrderspage}
                    previousLabel={'Prev'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={inprogresspageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handleprogressPageClick}
                    containerClassName={'pagination flex-wrap'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                </div>
                : null}
              {(chemistinprogressOrderDetails === undefined ||
                chemistinprogressOrderCount === 0) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">
                    No processing orders to show!
                  </div>
                </div>}
            </Tab>

            <Tab eventKey="complete" title="Completed">
              <div className="tabsdiv">
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <h5 className="tablecardtitle">
                        Urgent Orders - Completed
                      </h5>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="commonInputdiv">
                      <div className="commonInput">
                        <i className="fa fa-search fa-lg cmnSearchIcon" />
                        <input
                          type="text"
                          name="srchurgentComplete"
                          placeholder="Order ID / Org Name"
                          value={srchurgentComplete}
                          onChange={newurgentonChange}
                        />
                      </div>
                    </div>
                  </Col>

                  {/* <Col
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    style={{visibility: 'hidden'}}
                  >
                    <div className="commonFilterDiv">
                      <select
                        name="completefilter"
                        value={filterurgentcomplete}
                        onChange={filterurgentChange}
                        className="commonFilterSelect"
                      >
                        <option value="">All</option>
                        <option value="payNow">Prepaid</option>
                        <option value="payLater">Postpaid</option>
                      </select>
                    </div>
                  </Col> */}
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="salescommonRecrd">
                      <i className="cui-note icons cmnRecordIcon" />
                      <span className="cmnPageCount">
                        {completecount === undefined
                          ? 0
                          : <span>
                            {completecount}
                          </span>}
                      </span>
                      <span className="cmnResutText">Results</span>
                    </div>
                  </Col>
                </Row>
              </div>

              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Order ID</th>
                    <th>Chemist Name</th>
                    <th>Organization Name</th>

                    <th>Created Date</th>
                    <th>Amount</th>
                    <th>Payment Status</th>
                    <th>Order Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {chemistcompleteOrderDetails !== undefined &&
                    chemistcompleteOrderCount !== 0 &&
                    chemistcompleteOrderDetails.map((item, i) =>
                      <tr key={i}>
                        <th scope="row">
                          {10 * (p5 - 1) + i + 1}
                        </th>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.orderNo
                            ? item.orderNo
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFrom
                            ? item.orderFrom.name + ' ' + item.orderFrom.lName
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFromName}
                        </td>

                        <td className="cmn_Cap">
                          {' '}{item !== null && item.createdAt
                            ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.invDtls.amount
                            ? 'INR ' + item.invDtls.amount
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.invDtls.status &&
                            item.invDtls.status === 'open'
                            ? <span className="badge badge-danger">
                              Not Paid
                            </span>
                            : <span className="badge badge-success">
                              {item.invDtls.status}
                            </span>}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.status &&
                            item.status === 'shipmentReady'
                            ? <span className="badge badge-warning">
                              Dispatched
                            </span>
                            : <span className="badge badge-success">
                              {item.status}
                            </span>}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              marginLeft: '15px',
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.showOrdersDetail({ item: item })}
                              />
                            </OverlayTrigger>

                            <ViewOrders
                              show={this.state.showViewOrdersDetailModal}
                              close={this.closeViewOrdersDetailModal}
                              ordersToShow={this.state.ordersToShow}
                              chemistOrderDtls={this.props.chemistOrderDtls}
                              chemistOrderDtlsCount={
                                this.props.chemistOrderDtlsCount
                              }
                              EditItemDetails={this.props.EditItemDetails}
                              ordersInActive={this.props.ordersInActive}
                              OrdersViewpageSelected={
                                this.props.OrdersViewpageSelected
                              }
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
              {completepageCount > 1
                ? <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={this.state.deliveredOrderspage}
                    previousLabel={'Prev'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={completepageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handledeliveredPageClick}
                    containerClassName={'pagination flex-wrap'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                </div>
                : null}
              {(chemistcompleteOrderDetails === undefined ||
                chemistcompleteOrderCount === 0) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">
                    No completed orders to show!
                  </div>
                </div>}
            </Tab>

            <Tab eventKey="cancel" title="Cancelled">
              <div className="tabsdiv">
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div>
                      <h5 className="tablecardtitle">
                        {' '}Urgent Orders - Cancelled
                      </h5>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="commonInputdiv">
                      <div className="commonInput">
                        <i className="fa fa-search fa-lg cmnSearchIcon" />
                        <input
                          type="text"
                          name="srchurgentCancel"
                          placeholder="Order ID / Org Name"
                          value={srchurgentCancel}
                          onChange={newurgentonChange}
                        />
                      </div>
                    </div>
                  </Col>

                  {/* <Col
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    style={{visibility: 'hidden'}}
                  >
                    <div className="commonFilterDiv">
                      <select
                        name="cancelfilter"
                        value={filterurgentcancel}
                        onChange={filterurgentChange}
                        className="commonFilterSelect"
                      >
                        <option value="">All</option>
                        <option value="payNow">Prepaid</option>
                        <option value="payLater">Postpaid</option>
                      </select>
                    </div>
                  </Col> */}
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <div className="salescommonRecrd">
                      <i className="cui-note icons cmnRecordIcon" />
                      <span className="cmnPageCount">
                        {cancelledcount === undefined
                          ? 0
                          : <span>
                            {cancelledcount}
                          </span>}
                      </span>
                      <span className="cmnResutText">Results</span>
                    </div>
                  </Col>
                </Row>
              </div>

              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Order ID</th>
                    <th>Chemist Name</th>
                    <th>Organization Name</th>
                    <th>Payment Mode</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {chemistcancelledOrderDetails !== undefined &&
                    chemistcancelledOrderCount !== 0 &&
                    chemistcancelledOrderDetails.map((item, i) =>
                      <tr key={i}>
                        <th scope="row">
                          {10 * (p6 - 1) + i + 1}
                        </th>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.orderNo
                            ? item.orderNo
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFrom
                            ? item.orderFrom.name + ' ' + item.orderFrom.lName
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderFromName}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.payMode ? item.payMode : null}
                        </td>
                        <td className="cmn_Cap">
                          {' '}{item !== null && item.createdAt
                            ? dateFormat(item.createdAt, 'dd-mmm-yyyy')
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          <span className="badge badge-danger">
                            {item && item.status}
                          </span>
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              marginLeft: '15px',
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.showOrdersDetail({ item: item })}
                              />
                            </OverlayTrigger>

                            <ViewOrders
                              show={this.state.showViewOrdersDetailModal}
                              close={this.closeViewOrdersDetailModal}
                              ordersToShow={this.state.ordersToShow}
                              chemistOrderDtls={this.props.chemistOrderDtls}
                              chemistOrderDtlsCount={
                                this.props.chemistOrderDtlsCount
                              }
                              EditItemDetails={this.props.EditItemDetails}
                              ordersInActive={this.props.ordersInActive}
                              OrdersViewpageSelected={
                                this.props.OrdersViewpageSelected
                              }
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
              {cancelledOrdersPageCount > 1
                ? <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={this.state.cancelledOrderspage}
                    previousLabel={'Prev'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={cancelledOrdersPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlecancelledPageClick}
                    containerClassName={'pagination flex-wrap'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                </div>
                : null}
              {(chemistcancelledOrderDetails === undefined ||
                chemistcancelledOrderCount === 0) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">
                    No cancelled orders to show!
                  </div>
                </div>}
            </Tab>
          </Tabs>
        </Card>
      </div>
    );
  }
}
export default withRouter(Orders);
